export const FATURAMENTO_INCREMENTAL_HOME_FLOW_ID = '79661bc1-970a-4167-b14b-c3f14a32d61a'
export const FATURAMENTO_INCREMENTAL_PAGE_FLOW_ID = '117a04f0-d689-4641-8343-726324e267ed'
